export const items = [
    {
        id: "casino",
        label: "Casino",
    },
    {
        id: "tournaments",
        label: "Tournaments",
    },
    {
        id: "live",
        label: "Live Casino",
    },
    {
        id: "pvp",
        label: "PvP",
    }
];
